// Helper function to extract component name from fiber
export default function getComponentName(fiber) {
  const type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
  if (!type) {
    return undefined;
  }
  if (typeof type === 'function' || typeof type === 'object') {
    return type.displayName || type.name;
  }
  return undefined;
}